// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-container {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  touch-action: manipulation;
}

.checkbox-container.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.checkbox-input {
  display: none;
}

.checkbox-custom {
  width: 16px;
  height: 16px;
  border: 1px solid var(--color-gray);
  border-radius: 3px;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
  background-color: var(--color-white);
}

.checkbox-custom.checked {
  background-color: var(--color-primary-green);
  border-color: var(--color-primary-green);
}

.checkbox-custom.checked::after {
  content: "";
  position: absolute;
  left: 2px;
  top: 1px;
  width: 8px;
  height: 6px;
  border: 2px solid var(--text-on-accent);
  border-top: none;
  border-right: none;
  transform: rotate(-45deg);
}

.checkbox-custom.disabled {
  background-color: var(--color-light-gray);
  border-color: var(--color-gray);
  cursor: not-allowed;
}

.checkbox-custom.disabled.checked {
  background-color: var(--color-gray);
  border-color: var(--color-gray);
}

.checkbox-label {
  color: var(--color-black);
  flex: 1;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .checkbox-custom {
    
  }

  .checkbox-custom.checked::after {
    left: 2px;
    top: 1px;
    width: 8px;
    height: 6px;
  }
  
  .checkbox-container {
    gap: 10px;
  }
}

/* Checkbox Group Styles */
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.checkbox-group .checkbox-container {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Checkbox/Checkbox.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,OAAO;AACT;;AAEA,6BAA6B;AAC7B;EACE;;EAEA;;EAEA;IACE,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;EACb;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".checkbox-container {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n  touch-action: manipulation;\n}\n\n.checkbox-container.disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.checkbox-input {\n  display: none;\n}\n\n.checkbox-custom {\n  width: 16px;\n  height: 16px;\n  border: 1px solid var(--color-gray);\n  border-radius: 3px;\n  position: relative;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  background-color: var(--color-white);\n}\n\n.checkbox-custom.checked {\n  background-color: var(--color-primary-green);\n  border-color: var(--color-primary-green);\n}\n\n.checkbox-custom.checked::after {\n  content: \"\";\n  position: absolute;\n  left: 2px;\n  top: 1px;\n  width: 8px;\n  height: 6px;\n  border: 2px solid var(--text-on-accent);\n  border-top: none;\n  border-right: none;\n  transform: rotate(-45deg);\n}\n\n.checkbox-custom.disabled {\n  background-color: var(--color-light-gray);\n  border-color: var(--color-gray);\n  cursor: not-allowed;\n}\n\n.checkbox-custom.disabled.checked {\n  background-color: var(--color-gray);\n  border-color: var(--color-gray);\n}\n\n.checkbox-label {\n  color: var(--color-black);\n  flex: 1;\n}\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n  .checkbox-custom {\n    \n  }\n\n  .checkbox-custom.checked::after {\n    left: 2px;\n    top: 1px;\n    width: 8px;\n    height: 6px;\n  }\n  \n  .checkbox-container {\n    gap: 10px;\n  }\n}\n\n/* Checkbox Group Styles */\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.checkbox-group .checkbox-container {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
